module.exports = __webpack_public_path__ + "img/item11.3fe237e1.png";